module.exports = __webpack_public_path__ + "static/ff-clan-std-news-2056b671d3be0a682255e156469ff770.woff";